const clauseCardDesc = [
  {
    type: "description",
    category: [`residential`, `fsbo`, `mere`],
    title: "Common Conditions/Subjects",
    text: `<p>
    The majority of clauses can be found within the
    <a
      href="https://www.bcfsa.ca/industry-resources/real-estate-professional-resources/knowledge-base/clauses/clauses"
      target="_blank"
      rel="noopener noreferrer"
    >
      BCFSA Clause Section </a> of the website or by using Webforms. Review the clauses to become 
      familiar with the clauses available to you. The BCFSA Clause section contains 
      alternate versions of some of the clauses listed below, which may better suit 
      your client's needs.
    <br />
    <br />
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your client's
    best interests. Any custom clause(s) should be written by your client's
    lawyer.
  </p>
  `,
  },
  {
    type: "description",
    category: `assign`,
    title: "Common Conditions/Clauses",
    text: `<p>
    Since assignments involve the purchasing of a Contract of Purchase & Sale, 
    it is important to review the Original Contract to understand the terms & 
    conditions relating to the agreement that is for sale. Advise your client to 
    choose a lawyer well-versed in assignments, as these deals tend to be more 
    complex compared to other transaction types. Refer to the <a
    href="https://www.bcfsa.ca/industry-resources/real-estate-professional-resources/knowledge-base/clauses/clauses"
    target="_blank"
    rel="noopener noreferrer"
  >
    BCFSA Clause Section</a> or Webforms for additional clauses that may apply.<br/>
    <br />
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your client's
    best interests. Any custom clause(s) should be written by your client's
    lawyer. 
  </p>`,
  },
  {
    type: "description",
    category: `precon`,
    title: "Common Conditions/Clauses",
    text: `<p>
    In pre-construction purchases, the majority of contracts will use the 
    Builder's Forms. It is essential to thoroughly read and understand the terms 
    of the agreement, particularly the clauses.
    <br /><br/>
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your client's
    best interests. Any custom clause(s) should be written by your client's
    lawyer.<br/><br/>
    <p>Important key elements to look out for: </p>
    <ol>
    <li>Have a Lawyer review the Agreement before signing</li>
    <li>Deposit Structure</li>
    <li>Restrictions Relating to Assignments & Leasing</li>
    <li>Occupancy & Construction Delay Related Clauses</li>
    <li>Price Adjustments & Additional Costs</li>
    <li>Warranty Coverage</li>
    <li>Disclosure Statement</li>
    <li>Parking & Storage Assignments</li>
    <li>Strata Bylaws, Rules & Fees (if applicable)</li>
    <li>Developers right to change design, common areas...etc.</li>
    </ol>
  </p>`,
  },
  {
    type: "description",
    category: [`lease`, `landlordSRP`, `leaseMere`],
    title: "Tenancy Placement Resources",
    text: `<p>
    The majority of forms for tenancies can be found on the
    <a
href="https://www2.gov.bc.ca/gov/content/housing-tenancy/residential-tenancies/calculators-and-resources/tenancy-forms"      target="_blank"
      rel="noopener noreferrer"
    >
      BC Government Website</a>. 
    <br/><br/>In order to serve your client's best interests, you should be familiar 
    with the <a
    href="https://www.bclaws.gov.bc.ca/civix/document/id/complete/statreg/02078_01"
    target="_blank"
    rel="noopener noreferrer"
  >Residential Tenancy Act</a>. Illegal clauses, meaning 
    those that contravene the RTA, should not be included in 
    the agreement. Any clause in a lease agreement that contradicts the RTA is void.
    <br />
    <br />
    <strong>Important:</strong> Each deal is unique, so the responsibility
    is on every REALTOR® to perform proper due diligence as part of their
    legal obligation to provide competent service. Depending on the
    transaction, additional clauses may be required to protect your client's
    best interests. Any custom clause(s) should be written by your client's
    lawyer. 
  </p>`,
  },
  {
    type: "description",
    category: [`resListing`],
    title: "Common Clauses in Listing Agreements",
    text: `<p>
    Schedule A in the Listing Agreement is used to include any additional 
    agreed upon terms or services that aren't addressed in the standard form. 
    Services should be clearly documented. This 
    added level of transparency is to ensure that both parties are 
    aware of the services that are being provided and to avoid any 
    misunderstandings. 
    <br/><br/>
    <strong>Important:</strong> Remember, this is a legally binding 
    contract, so it is essential to only offer services that you are 
    both capable of delivering and willing to follow through on. Follow 
    the "underpromise, overdeliver" approach.
  </p>`,
  },
];

export default clauseCardDesc;
